import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuditResultDetail } from 'src/app/core-module/models/Audits/AuditResults/audit-result-detail';
import { AuditResultQuestion } from 'src/app/core-module/models/Audits/AuditResults/audit-result-question';
import { UtilService } from 'src/app/core-module/services/util.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-results-action-panel',
    templateUrl: './results-action-panel.component.html',
    styleUrl: './results-action-panel.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResultsActionPanelComponent {
  @Input() auditResultDetail: AuditResultDetail = new AuditResultDetail();

  public isBluebird: boolean = false;
  public actionsList: AuditResultQuestion[] = [];
  public actionQuestionList: AuditResultQuestion[] = [];
  public hasComments: boolean = false;
  public hasReference: boolean = false;
  constructor(private utilService: UtilService) {
    this.isBluebird = environment.blueBird;

  }

  ngOnChanges() {
    this.extractActions();
  }
  extractActions() {
    this.actionsList = [];
    this.actionQuestionList = [];
    this.auditResultDetail.Questions.forEach(q => {
      if (q.Actions.length > 0) {
        if (q.QuestionComments.length > 0) {
          this.hasComments = true;
        }
        if (q.ReferenceAnswer.length > 0) {
          this.hasReference = true;

        }
        this.actionQuestionList.push(q);
        /*q.Actions.forEach(act => {
          var actionRow: AuditResultQuestion = new AuditResultQuestion(q);
          actionRow.Actions = [];
          actionRow.Actions.push(act);
          this.actionsList.push(actionRow);
   
        })*/
      }
    });
  }
  humanDate(date: Date) {
    return this.utilService.humanDate(date);
  }

}
